var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"muniMap",staticClass:"muni-map",style:({ height: (_vm.height + "px") }),attrs:{"center":_vm.center || _vm.j.location,"zoom":_vm.j.location.zoom,"options":_vm.mapOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }